import styled from "styled-components";

export const MainContainer = styled.main`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
  min-height: 100vh;
  background-color: #000000;
  padding: 24px 16px;
  box-sizing: border-box;

  p {
    color: #ccc;
    font-family: "Mark For MC Narrow W00 Light";
    font-size: 16px;
    font-style: normal;
    font-weight: 350;
    line-height: 24px;
    letter-spacing: 0.5px;
    margin: 0;
    text-align: center;
  }

  h1 {
    font-family: "Mark For MC Narrow W00 Light";
    font-size: 24px;
    font-style: normal;
    font-weight: 350;
    line-height: 32px;
    color: #fff;
    text-align: center;
    margin: 0;
  }

  a {
    color: #ccc;
    font-family: "Mark For MC Narrow W00 Light";
    font-size: 16px;
    font-weight: 350;
    line-height: 24px;
    letter-spacing: 0.5px;
    text-align: center;
    text-decoration: underline;
  }
`;

export const IntroSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  padding: 40px 16px;
  width: 100%;
  border-radius: 6px;
  background-color: #282827;
  box-sizing: border-box;

  .intro-logo {
    width: 258px;
    height: 55px;
    flex-shrink: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      display: block;
    }
  }

  .intro-text {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    align-items: center;
  }

  .intro-body {
    display: flex;
    flex-direction: column;
    gap: 11px;
    width: 100%;
  }

  .help-contact {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0;
    width: 100%;
    text-align: center;

    a {
      display: block;
      width: 100%;
      text-align: center;
    }
  }
`;

export const BalanceSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;
  padding: 8px 24px 16px;
  border-radius: 4px;
  background-color: #282827;
  box-sizing: border-box;

  .balance-label {
    color: #ccc;
    font-family: "Mark For MC Narrow W00 Light";
    font-size: 16px;
    font-weight: 350;
    line-height: 24px;
    letter-spacing: 0.5px;
    text-align: center;
    white-space: nowrap;
  }

  .balance-value {
    color: #fff;
    font-family: "Mark For MC Narrow W00 Light";
    font-size: 28px;
    font-weight: 350;
    line-height: 32px;
    text-align: center;
    white-space: nowrap;
    margin: 0;
  }
`;

export const Footer = styled.footer`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 0 -16px -24px;
  width: calc(100% + 32px);
  padding: 24px 16px 48px;
  border-top: 1px solid #000;
  background-color: #282827;
  box-sizing: border-box;

  .footer-block {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
  }

  .footer-label {
    color: #fff;
    font-family: "Mark For MC Narrow W00 Light";
    font-size: 12px;
    font-weight: 350;
    line-height: 24px;
    letter-spacing: 0.4px;
    margin: 0;
    white-space: nowrap;
  }

  img:not(.payme-logo) {
    height: 32px;
    width: auto;
    cursor: pointer;
  }

  .payme-logo {
    height: 48px;
    width: auto;
    cursor: pointer;
  }
`;
